var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:{ ..._vm.GetResponsiveClass, ..._vm.IsUsedInHomeComponent },attrs:{"id":"company-logo","src":_vm.GetLogo},on:{"click":_vm.OnLogoClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }